import { createActionTypes } from "../../../utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...createActionTypes("ACTIVITIES", "FETCH_ACTIVITIES_LIST" ),
    ...createActionTypes("ACTIVITIES", "FETCH_ACTIVITY_BY_ID"),
    ...createActionTypes("ACTIVITIES", "FETCH_ACTIVITIES_BY_SEARCH"),
}

export const CLEAR_ACTIVITIES_BY_SEARCH = "CLEAR_ACTIVITIES_BY_SEARCH"